import { httpRequest } from '../../shared/lib/utils/httpClient';

export interface OtpType {
  otp: string;
}

export interface MFASetup {
  userId: number;
  username: string;
}

export interface TwoFactorAuthResponse {
  qrCodeUrl: string;
  secretKey: number;
  message: string;
}

export interface MFACodeValidationResponse {
  code: number;
  status: string;
  message: string;
  accessToken: string;
}

export const getMFADetails = async (
  payload: MFASetup
): Promise<TwoFactorAuthResponse> => {
  const response = await httpRequest<TwoFactorAuthResponse>({
    url: `/facility/user/mfa/setup`,
    method: 'POST',
    data: payload,
  });
  return response;
};

export const validateMFAToken = async (
  payload: OtpType
): Promise<MFACodeValidationResponse> => {
  const response = await httpRequest<MFACodeValidationResponse>({
    url: `/facility/user/mfa/validate-otp`,
    method: 'POST',
    data: payload,
  });
  return response;
};
